import React, { useEffect, useMemo, useState } from 'react';
import RegionSelectorOutSide from '@/pages/home/components/RegionSelect';
import NewRegionSelect from '@/pages/home/components/NewRegionSelect';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { getCountryFlag } from '@/pages/home/_config/countries';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';

import './index.scss'
import { getRegionSelectedData } from '../NewFilter/util';

interface Props {
  className: string
  value?: {
    regions: string[]
    markets: string[]
    region_type: 'region' | 'market'
  }
  popularList?: string[]
  activeTab?: 'common' | 'popular'
  locale?: 'en-US' | 'zh_CN'
  resultLable?: string[]
  globalDes?: string
  regionCountry?: any[]
  globalMessageHidden?: boolean
  globalMsg?: string
  language?: {[key: string]: string}
  onTabChange?: (activeTab?: 'common' | 'popular') => void
  onChange?: (value: any) => void
}

const ReactSelector = (props: Props) => {
  const {
    className,
    value,
    regionCountry,
    popularList,
    locale,
    globalMsg = '',
    globalMessageHidden = false,
    activeTab = 'common',
    resultLable,
    globalDes,
    onTabChange,
    onChange,
    language
  } = props;
  const [isHover, setIsHover] = useState(false);
  const { getLocalText } = useLocal('region_selector')
  const hiddenList = ['all areas', 'ALL AREAS', 'global', 'GLOBAL'];

  const radioOptions = [
    {
      value: '255',
      text: 'All',
      textCN: '全部',
      infoIcon: <span style={{ display: 'flex', alignItems: 'center' }}
        onMouseOver={() => { setIsHover(true) }} onMouseOut={() => { setIsHover(false) }}
      >
        <>
          {
            !globalMessageHidden ? (
              <Bubble
                style={{
                  // width: 350,
                  left: -18,
                }}
                placement='bottom-start'
                content={globalMsg}
                dark
              >
                {/* 此处必须包一层，不然点击不生效 */}
                <i><SvgIcon className='select-header-ic' type={isHover ? 'alert-circle-action' : 'alert-circle-m'} /></i>
              </Bubble>
            ) : null
          }
        </>
      </span>
    }
  ];

  // 对数据格式进行处理，修改为新国家筛选器的格式
  const regionCountryOption = useMemo(() => {
    return regionCountry?.map((item) => {
      const itemObjChildren = item?.country?.map(items => {
        // 注意中英文和value的值（value有没有是英文名的特殊情况）
        return {
          ...items,
          text: items?.enText,
          icon: getCountryFlag(items?.country_code),
          textCN: items?.chText,
          value: items?.country_code
        }

      })
      return {
        ...item,
        country: itemObjChildren,
        children: itemObjChildren,
        text: item?.region_name_en,
        textCN: item?.region_name_cn,
        value: item?.region_abbre

      }
    })?.filter(item => !hiddenList.includes(item?.region_abbre?.toLowerCase()))
  }, [regionCountry])


  const resultValue = useMemo(() => {
    return getRegionSelectedData(regionCountryOption, value)
  }, [value, regionCountry])

  const handleNewConfirm = (value: any) => {
    let resultVal = value || {};
    const marketValue = resultVal?.markets || [];
    if (marketValue?.length > 1 && marketValue?.includes('255')) {
      resultVal = {
        ...value,
        markets: marketValue?.filter((item: string) => item !== '255')
      }
    }
    onChange?.(resultVal)
  }
  return (
    <Bubble
      dark
      escapeWithReference
      flipped={false}
      destroyOnClose={false}
      content={getLocalText('region_selector_global_tips', {}, false)}
    >
      <NewRegionSelect
        value={resultValue}
        className={className}
        language={language}
        dropdownClassName='region-selector-dropdown'
        radioOptions={radioOptions}
        options={regionCountryOption}
        onCloseReginSelect={handleNewConfirm}
        onChange={(value) => {
          onChange?.(value);
          handleNewConfirm(value);
        }}
        closeOnScroll={true}
        popularList={popularList?.length ? popularList : ['ru', 'tr', 'us', 'br', 'mx']}
        locale={locale}
        activeTab={activeTab}
        onTabChange={onTabChange}
      />
    </Bubble>

  )
}

export default ReactSelector;
